import { render, staticRenderFns } from "./NewConversationPopup.vue?vue&type=template&id=8910ae1e&"
import script from "./NewConversationPopup.vue?vue&type=script&lang=ts&"
export * from "./NewConversationPopup.vue?vue&type=script&lang=ts&"
import style0 from "./NewConversationPopup.vue?vue&type=style&index=0&id=8910ae1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports